import React from "react";
import { RunnerItem } from "./runner-item";
import { Box } from "@mui/material";
import { useResultsContext } from "../../../services/context/results-context";
import { PropertySection } from "./property-data";
import { useAppContext } from "../../../services/context/app-context";

//style
import './sidebar-results.css'
import { RunnerItemHoriz } from "./runner-item-horiz";

export const RunnerList = ({
  selectedRunner,
  setSelectedRunner,
}) => {
  const {runners} = useResultsContext();
  const {property} = useAppContext();

  return (
    <Box
    sx={{
      overflowY: "auto",
      padding: "8px 16px 16px 16px",
    }}
    className={'sidebar-results'}
    >
      <PropertySection propertyData={property} />
      <Box
              sx={{
                display: "flex",
                flexDirection: 'column',
                /* flexWrap: "wrap", */
                gap: "8px",
              }}
            >
            {runners.map((runner, i) => (
        <RunnerItemHoriz
          key={runner.id}
          isSelected={
            selectedRunner && selectedRunner.id === runner.id
          }
          runner={runner}
          setSelectedRunner={setSelectedRunner}
          index={i}
        />
      ))}  
            </Box>
      
    </Box>
  );
};
